(() => {
  if (!customElements.get("icon-with-text-mobile")) {
    class IconWithTextMobile extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        if (typeof Swiper === 'undefined') {
          console.error("Swiper is not loaded.");
          return;
        }

        this.swiperEl = this.querySelector("[data-icon-with-text-mobile-swiper]");
        this.progressBar = this.querySelector(".swiper-progress-fill");

        if (!this.swiperEl) return;

        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.3,
          spaceBetween: 0,
          loop: false,
          on: {
            init: () => this.updateProgress(),
            slideChange: () => this.updateProgress()
          }
        });

        // Shopify Design Mode section reload
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", () => {
            this.swiper.update();
            this.updateProgress();
          });
        }
      }

      updateProgress() {
        if (!this.swiper || !this.progressBar) return;

        const current = this.swiper.realIndex + 1;
        const total = this.swiper.slides.length;
        const percent = (current / total) * 100;

        this.progressBar.style.width = `${percent}%`;
      }
    }

    customElements.define("icon-with-text-mobile", IconWithTextMobile);
  }
})();
